var module = angular.module('octopusApp.projects');

module.controller('ProjectVariableCommonTemplatesController', function($scope, busy, pageTitle, projectState, octopusRepository) {
    var isLoading = $scope.isLoading = busy.create();

    isLoading.promise(projectState.load().then(function(project) {
        $scope.project = project;
        pageTitle(project.Name + ' Common Variable Templates');

        isLoading.promise(octopusRepository.LibraryVariableSets.all({ids: project.IncludedLibraryVariableSetIds}).then(function(lvs) {
            $scope.libraryVariableSets = _.filter(lvs, function (x) {
                return x.Templates.length > 0;
            });
        }));
    }));
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/variables/project_variables_common_templates.js
// module id = 576
// module chunks = 1